function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_236",
  "data-name": "Ellipse 236",
  cx: 211.976,
  cy: 12.192,
  rx: 211.976,
  ry: 12.192,
  transform: "translate(0 219.617)",
  fill: "#f2f2f2"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_571",
  "data-name": "Rectangle 571",
  width: 318.449,
  height: 10.131,
  transform: "translate(67.511)",
  fill: "#f2f2f2"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_237",
  "data-name": "Ellipse 237",
  cx: 2.622,
  cy: 2.622,
  r: 2.622,
  transform: "translate(73.411 2.294)",
  fill: "#f0b543"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_238",
  "data-name": "Ellipse 238",
  cx: 2.622,
  cy: 2.622,
  r: 2.622,
  transform: "translate(81.932 2.294)",
  fill: "#f0b543"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_239",
  "data-name": "Ellipse 239",
  cx: 2.622,
  cy: 2.622,
  r: 2.622,
  transform: "translate(90.454 2.294)",
  fill: "#f0b543"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "Path_568",
  "data-name": "Path 568",
  d: "M175.193,333.289l-.226.194v68.343H493.416V281.779l-3.8.288Z",
  transform: "translate(-107.456 -173.055)",
  fill: "#3f3d56"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_572",
  "data-name": "Rectangle 572",
  width: 88.927,
  height: 3.586,
  transform: "translate(90.493 67.771)",
  fill: "#3f3d56"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_573",
  "data-name": "Rectangle 573",
  width: 88.927,
  height: 3.586,
  transform: "translate(90.493 75.66)",
  fill: "#3f3d56"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_574",
  "data-name": "Rectangle 574",
  width: 30.12,
  height: 3.586,
  transform: "translate(90.493 83.548)",
  fill: "#3f3d56"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_575",
  "data-name": "Rectangle 575",
  width: 88.927,
  height: 3.586,
  transform: "translate(271.842 167.32)",
  fill: "#fff"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_576",
  "data-name": "Rectangle 576",
  width: 88.927,
  height: 3.586,
  transform: "translate(271.842 175.209)",
  fill: "#fff"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_577",
  "data-name": "Rectangle 577",
  width: 30.12,
  height: 3.586,
  transform: "translate(271.842 183.098)",
  fill: "#fff"
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_240",
  "data-name": "Ellipse 240",
  cx: 3.498,
  cy: 3.498,
  r: 3.498,
  transform: "translate(213.093 218.47)",
  fill: "#f2f2f2"
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_241",
  "data-name": "Ellipse 241",
  cx: 3.498,
  cy: 3.498,
  r: 3.498,
  transform: "translate(223.237 218.819)",
  fill: "#f2f2f2"
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_242",
  "data-name": "Ellipse 242",
  cx: 3.498,
  cy: 3.498,
  r: 3.498,
  transform: "translate(233.382 219.169)",
  fill: "#f2f2f2"
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_243",
  "data-name": "Ellipse 243",
  cx: 2.798,
  cy: 2.798,
  r: 2.798,
  transform: "translate(223.969 219.519)",
  fill: "#3f3d56"
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_578",
  "data-name": "Rectangle 578",
  width: 30.12,
  height: 6.872,
  transform: "translate(119.818 108.815)",
  fill: "#3f3d56"
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_579",
  "data-name": "Rectangle 579",
  width: 30.12,
  height: 6.872,
  transform: "translate(298.852 201.805)",
  fill: "#fff"
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_244",
  "data-name": "Ellipse 244",
  cx: 20.836,
  cy: 20.836,
  r: 20.836,
  transform: "translate(114.212 91.452)",
  fill: "#f0b543",
  opacity: 0.3
});

var _ref21 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_245",
  "data-name": "Ellipse 245",
  cx: 13.891,
  cy: 13.891,
  r: 13.891,
  transform: "translate(121.157 98.397)",
  fill: "#f0b543",
  opacity: 0.3
});

var _ref22 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_246",
  "data-name": "Ellipse 246",
  cx: 9.646,
  cy: 9.646,
  r: 9.646,
  transform: "translate(125.401 102.642)",
  fill: "#f0b543"
});

var _ref23 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_247",
  "data-name": "Ellipse 247",
  cx: 20.836,
  cy: 20.836,
  r: 20.836,
  transform: "translate(289.532 39.814)",
  fill: "#f0b543",
  opacity: 0.3
});

var _ref24 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_248",
  "data-name": "Ellipse 248",
  cx: 13.891,
  cy: 13.891,
  r: 13.891,
  transform: "translate(296.477 46.759)",
  fill: "#f0b543",
  opacity: 0.3
});

var _ref25 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_249",
  "data-name": "Ellipse 249",
  cx: 9.646,
  cy: 9.646,
  r: 9.646,
  transform: "translate(300.722 51.004)",
  fill: "#f0b543"
});

var _ref26 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_250",
  "data-name": "Ellipse 250",
  cx: 20.836,
  cy: 20.836,
  r: 20.836,
  transform: "translate(293.246 184.441)",
  fill: "#f0b543",
  opacity: 0.3
});

var _ref27 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_251",
  "data-name": "Ellipse 251",
  cx: 13.891,
  cy: 13.891,
  r: 13.891,
  transform: "translate(300.191 191.387)",
  fill: "#f0b543",
  opacity: 0.3
});

var _ref28 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_252",
  "data-name": "Ellipse 252",
  cx: 9.646,
  cy: 9.646,
  r: 9.646,
  transform: "translate(304.435 195.631)",
  fill: "#f0b543"
});

var _ref29 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_580",
  "data-name": "Rectangle 580",
  width: 8.582,
  height: 11.034,
  transform: "translate(43.272 42.529) rotate(-177.779)",
  fill: "#f0b543"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  id: "Path_569",
  "data-name": "Path 569",
  d: "M241.461,310.274s11.876-5.674,11.686-.774-11.971,8.124-11.971,8.124Z",
  transform: "translate(-167.652 -240.487)",
  fill: "#ffb9b9"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  id: "Path_570",
  "data-name": "Path 570",
  d: "M146.6,411.7s5.6,13.714,7.673,23.61,5.223,23.515,1.168,33.173-15.585,38.045-15.7,41.107.988,6.173-1.463,6.078-15.784-4.293-16.325-6.154,4.549-6.572,4.549-6.572l12.57-39.388-13.115-25.661-9.46,38.282-1.853,47.779s-9.093-2.807-10.413-.4c0,0-4.074-5.679-4.592-8.153s1.924-49.617,1.924-49.617-8.347-53.7-1.609-53.435S133.077,396.453,146.6,411.7Z",
  transform: "translate(-79.302 -300.451)",
  fill: "#2f2e41"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  id: "Path_571",
  "data-name": "Path 571",
  d: "M173.483,678.521s6.215,13.737,6.8,14.374,4.639,6.928,1.576,6.809-10.295-3.467-15.618-8.581-12.341-13.975-11.7-14.564a36.143,36.143,0,0,1,5-2.26Z",
  transform: "translate(-114.42 -465.753)",
  fill: "#2f2e41"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  id: "Path_572",
  "data-name": "Path 572",
  d: "M120.685,703.236s.375,6.149,1.505,8.647.988,6.173-2.075,6.054-10.978-1.653-10.978-1.653-.47-3.7.166-4.288,3.348-7.232,2.194-9.117S120.685,703.236,120.685,703.236Z",
  transform: "translate(-86.457 -482.843)",
  fill: "#2f2e41"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  id: "Path_573",
  "data-name": "Path 573",
  d: "M112.275,187.821S105.745,198,103.2,200.352s4.615,7.541,4.615,7.541l12.816,1.724s-.161-11.662.5-12.864S112.275,187.821,112.275,187.821Z",
  transform: "translate(-82.578 -166.982)",
  fill: "#ffb9b9"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  id: "Path_574",
  "data-name": "Path 574",
  d: "M116.742,217.867s-2.64,4.805-5.09,4.71-15.124-5.494-15.665-7.356-4.2,13.334-4.2,13.334L122.8,283.13l7.564-5.228L126.7,245.859l-3.01-17.294Z",
  transform: "translate(-75.906 -183.714)",
  fill: "#f0b543"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  id: "Path_575",
  "data-name": "Path 575",
  d: "M79.424,260.841a17.161,17.161,0,0,1,1.9,8.049c0,.122-.009.245-.02.367-.293,5.669-2.382,12.226-3.131,16.995-.544,3.421-.389,5.917,1.613,6.5,4.853,1.415-.708,2.426,18.068,8.676s22.052.855,22.1-.37-2.659-10.532-2.023-11.121,8.9,7.707,11.4,6.577.285-7.351.285-7.351-5.627-13.1-5.508-16.164-8.523-17.508-8.523-17.508l-5.878-38.263s-2.26-5-5.3-5.727a7.528,7.528,0,0,0-5.56,1.011l5.085,11.24L109.3,243.6l-.9,7.327s-6.239-13.125-10.337-18.192-12.835-17.062-12.835-17.062-2.04-6.883-.5-8.939-6.423-2.372-9.818,6.085c-1.8,4.482-4.721,11.166-6.551,17.389-1.631,5.513-2.4,10.667-.786,13.613C70.045,248.319,76.257,254.234,79.424,260.841Z",
  transform: "translate(-60.487 -177.846)",
  fill: "#575a89"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  id: "Path_576",
  "data-name": "Path 576",
  d: "M67.576,280.7c2.47,4.5,8.682,10.416,11.849,17.023.827-2.98,1.836-6.064,1.836-6.064s3.87-20.708-7.578-26.06a7.662,7.662,0,0,0-5.321,1.487C66.73,272.6,65.96,277.756,67.576,280.7Z",
  transform: "translate(-60.487 -214.73)",
  opacity: 0.1
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  id: "Path_577",
  "data-name": "Path 577",
  d: "M185.271,301.411l9.706,2.83,13.476.523,1.386,11.71-22.147,1.6S182.161,302.518,185.271,301.411Z",
  transform: "translate(-132.735 -236.744)",
  fill: "#575a89"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  id: "Path_578",
  "data-name": "Path 578",
  d: "M138.688,403.451s12.984,2.154,10.021,6.062-14.466-.2-14.466-.2Z",
  transform: "translate(-101.979 -299.412)",
  fill: "#ffb9b9"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  id: "Path_579",
  "data-name": "Path 579",
  d: "M99.6,370.725c-.293,5.669-2.382,12.226-3.131,16.995,4.136,3.915,8.07,7.368,9.552,7.425,3.063.119,7.987-.3,9.8.38s2.878-10.931,2.878-10.931-1.083-3.723-5.912-5.751A67.26,67.26,0,0,1,99.6,370.725Z",
  transform: "translate(-78.778 -279.313)",
  opacity: 0.1
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  id: "Path_580",
  "data-name": "Path 580",
  d: "M69.549,256.068s-10.366-1.629-9.806,15.57-1.093,28.177,3.076,31.406,17.712,17.864,20.774,17.983,7.987-.3,9.8.38,2.878-10.931,2.878-10.931-1.083-3.723-5.912-5.751-16.206-9.217-16.111-11.667,2.878-10.931,2.878-10.931S81,261.42,69.549,256.068Z",
  transform: "translate(-56.212 -208.871)",
  fill: "#575a89"
});

var _ref42 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_253",
  "data-name": "Ellipse 253",
  cx: 13.486,
  cy: 13.486,
  r: 13.486,
  transform: "translate(25.351 8.934)",
  fill: "#ffb9b9"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  id: "Path_581",
  "data-name": "Path 581",
  d: "M135.843,137.487a2.6,2.6,0,0,0,1.134.569.809.809,0,0,0,.938-.65,3.362,3.362,0,0,0,1.287,1.65c.63.328,1.6.053,1.695-.652a2.974,2.974,0,0,0,.684,1.445,1.025,1.025,0,0,0,1.441.048,37.034,37.034,0,0,0-.192,4.588,5.842,5.842,0,0,1-1.651,4.159c-1.686,1.468-4.222,1.105-6.44.827a1.955,1.955,0,0,0-1.009.055c-.83.354-.793,1.51-.8,2.413a6.7,6.7,0,0,1-5.87,6.366,3.36,3.36,0,0,1-2.5-.609c-.63-.534-.951-1.4-1.673-1.8-1.174-.652-2.6.3-3.456,1.332s-1.7,2.3-3.033,2.492c-1.758.25-3.1-1.542-3.755-3.192a18.607,18.607,0,0,1,.37-14.458C116.683,134.064,129.224,132.8,135.843,137.487Z",
  transform: "translate(-87.925 -134.397)",
  fill: "#2f2e41"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  id: "Path_582",
  "data-name": "Path 582",
  d: "M1008.694,668.893c4.75,8.1,14.329,11.307,14.329,11.307s1.879-9.926-2.871-18.026-14.329-11.307-14.329-11.307S1003.944,660.793,1008.694,668.893Z",
  transform: "translate(-637.035 -451.363)",
  fill: "#f2f2f2"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  id: "Path_583",
  "data-name": "Path 583",
  d: "M992.734,685.607c8.214,4.549,11.655,14.047,11.655,14.047s-9.877,2.122-18.091-2.428-11.655-14.047-11.655-14.047S984.52,681.058,992.734,685.607Z",
  transform: "translate(-618.111 -470.904)",
  fill: "#f0b543"
});

function SvgWebinar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_93_1",
    "data-name": "Component 93 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 423.952,
    height: 244,
    viewBox: "0 0 423.952 244",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebinar);
export default __webpack_public_path__ + "static/media/webinar.1d6a66da.svg";
export { ForwardRef as ReactComponent };